import { defineStore } from "pinia";
import { ref, computed, watch, onMounted } from "vue";
import Prompt from "@utils/Prompt";

import { validationCheck } from "@utils";

import { useSettings } from "@store/settings";

import { useRouter, useRoute } from "vue-router";

export const useChatCustomizer = defineStore("chatCustomizer", () => {
  const $settings = useSettings();
  const route = useRoute();
  const router = useRouter();

  const sidebarWidth = ref("495px");

  const selectedPrimaryMenu = ref("widget");

  const sidebarStepMenu = ref([
    {
      id: "banner",
      title: `${$settings.settings.chat_widget.banner?.label}`,
      link: { name: "customizer.chat.banner" },
    },
    {
      id: "welcome",
      title: `${$settings.settings.chat_widget.welcome?.label}`,
      link: { name: "customizer.chat.welcome" },
    },
    {
      id: "overview",
      title: `${$settings.settings.chat_widget.overview?.label}`,
      link: { name: "customizer.chat.overview" },
    },
  ]);

  const sidebarStepDragMenu = ref([
    {
      id: "service",
      priority: $settings.settings.chat_widget.service.priority,
      title: `${$settings.settings.chat_widget.service?.label}`,
      link: { name: "customizer.chat.service" },
    },
    {
      id: "staff",
      priority: $settings.settings.chat_widget.staff.priority,
      title: `${$settings.settings.chat_widget.staff?.label}`,
      link: { name: "customizer.chat.staff" },
    },
    {
      id: "date",
      priority: $settings.settings.chat_widget.date.priority,
      title: `${$settings.settings.chat_widget.date?.label}`,
      link: { name: "customizer.chat.date" },
    },
    {
      id: "time",
      priority: $settings.settings.chat_widget.time.priority,
      title: `${$settings.settings.chat_widget.time?.label}`,
      link: { name: "customizer.chat.time" },
    },
    {
      id: "account",
      priority: $settings.settings.chat_widget.account.priority,
      title: `${$settings.settings.chat_widget.account?.label}`,
      link: { name: "customizer.chat.account" },
    },
  ]);

  const primarySidebarMenu = ref([
    {
      id: "widget",
      name: "Widget",
      icon: "geometricShapes01",
    },
    // {
    //     id: 'design',
    //     name: 'Design',
    //     icon: 'colorPicker',
    // },
    // {
    //     id: 'settings',
    //     name: 'Settings',
    //     icon: 'settingDone04',
    // },
  ]);

  const selectedSecondaryMenu = ref("top-banner");

  const secondarySidebarMenu = ref([
    {
      id: "title",
      name: "Title",
      type: "group-name",
      children: [
        {
          id: "top-banner",
          name: "Top Banner",
          icon: "insertTopImage",
          link: { name: "chat.customizer.top-banner" },
        },
        {
          id: "welcome-title",
          name: "Welcome Title",
          icon: "edit02",
          link: { name: "chat.customizer.welcome-title" },
        },
      ],
    },
    {
      id: "action",
      name: "Action",
      type: "group-name",
      children: [
        {
          id: "service",
          name: "Service",
          icon: "layerAdd",
          link: { name: "chat.customizer.service" },
        },
        {
          id: "staff",
          name: "Staff",
          icon: "user",
          link: { name: "chat.customizer.staff" },
        },
        {
          id: "date",
          name: "Date",
          icon: "calendar03",
          link: { name: "chat.customizer.date" },
        },
        {
          id: "time",
          name: "Time",
          icon: "clock",
          link: { name: "chat.customizer.time" },
        },
        // {
        //     id:'appointment-type',
        //     name:'Appointment Type',
        //     icon:'calendar03',
        // },
        // {
        //     id:'requirements',
        //     name:'Requirements',
        //     icon:'calendar03',
        // },
        // {
        //     id:'extra-service',
        //     name:'Extra Service',
        //     icon:'calendar03',
        // }
      ],
    },
    {
      id: "checkout",
      name: "Checkout",
      type: "group-name",
      children: [
        {
          id: "account",
          name: "Customer Information",
          icon: "login03",
          link: { name: "chat.customizer.account" },
        },
        {
          id: "overview",
          name: "Overview",
          icon: "energy",
          link: { name: "chat.customizer.overview" },
        },
      ],
    },
  ]);

  const changeSecondaryMenu = (menuChildId) => {
    selectedSecondaryMenu.value = menuChildId;

    let childMenus = secondarySidebarMenu.value.map((menu) => menu.children);
    let menu = childMenus.flat().find((menu) => menu.id == menuChildId);

    if (menu && menu.link) {
      router.push(menu.link);
    }
  };

  onMounted(() => {
    const currentRouteName = router.currentRoute.value.name;
    const childMenus = secondarySidebarMenu.value.map((menu) => menu.children);
    const matchingMenu = childMenus
      .flat()
      .find((menu) => menu.link?.name === currentRouteName);

    if (matchingMenu) {
      changeSecondaryMenu(matchingMenu.id);
    }
  });
  // const sidebarWidgetMenu = ref([
  //     {
  //         id: 'general',
  //         title: 'General',
  //         link: { name: 'customizer.widget.general' },
  //         visible: true,
  //         children: [
  //             { id: 'show_widget', title: 'Show Widget', selectedType: 'boolean', selected: false, component: 'Toggle' }
  //         ]
  //     },
  // ]);

  const defaultCustomizer = ref({});

  // return object from sidebar menu array.children
  // const getMenuStatusById = (parentId, childrenId) => {
  //     if (!parentId || !childrenId) return false;

  //     let menu = [
  //         ...sidebarFormMenu.value,
  //         ...sidebarWidgetMenu.value,
  //     ];

  //     let item = menu.find(menu => menu.id == parentId).children.find(menu => menu.id == childrenId);

  //     if (!item.selected) {
  //         switch (item.selectedType) {
  //             case "boolean":
  //                 return false;
  //             case "string":
  //                 return '';
  //             default:
  //                 return false;
  //         }
  //     }

  //     return item.selected;
  // };

  const cancel = async (reload = false) => {
    Toast.success("Test: Chat customizer updated successfully");
    // await isCustomizerInputChanged();
    // const onSuccess = () => {
    //     if (reload) return window.location.href = `${prebook_admin.url.home}${prebook_admin.url.current}`;

    //     router.push({ name: 'dashboard' });
    // };

    // if (!isCustomizerChanged.value) return onSuccess();

    // const choice = await Prompt.fire({
    //     title: 'Unsaved Changes Detected',
    //     message: `You have unsaved changes. Any unsaved changes will be lost. <br> Are you sure you want to continue?`,
    //     ok: 'Yes, proceed',
    //     cancel: 'No, cancel',
    // });

    // if (choice.ok) {
    //     onSuccess();
    // }
  };

  const publish = async () => {
    await $settings.saveSettings("chat-widget");
    await syncWithCustomizer();
    console.log("Settings saved");
    Toast.success("Customizer updated successfully");
  };

  const resetCustomizer = async () => {
    Toast.success("Test: Chat customizer reset successfully");

    // let choice = await Prompt.fire({
    //     title: 'Warning: Reset Chat Customizer!',
    //     message: `This will reset the chat customizer to its original state. <br> All your changes will be lost. There's no going back! `,
    //     ok: 'Yes, proceed',
    //     cancel: 'No, cancel',
    // });

    // if (choice.ok) {
    //     // reset customizer
    //     $settings.settings.customizer = defaultCustomizer.value;

    //     // update customizer settings
    //     await $settings.saveSettings('customizer');

    //     setTimeout(() => {
    //         window.location.reload();
    //     }, 500);
    // }
  };

  const syncWithCustomizer = async () => {
    console.log("Syncing with customizer");
    $settings.customizer.customer_information.priority =
      $settings.settings.chat_widget.account.priority;
    $settings.customizer.date.priority =
      $settings.settings.chat_widget.date.priority;
    $settings.customizer.service.priority =
      $settings.settings.chat_widget.service.priority;
    $settings.customizer.staff.priority =
      $settings.settings.chat_widget.staff.priority;
    $settings.customizer.time.priority =
      $settings.settings.chat_widget.time.priority;
    await $settings.saveSettings("customizer");
  };

  return {
    sidebarWidth,
    primarySidebarMenu,
    secondarySidebarMenu,
    cancel,
    publish,
    resetCustomizer,
    selectedPrimaryMenu,
    selectedSecondaryMenu,
    changeSecondaryMenu,
    sidebarStepMenu,
    sidebarStepDragMenu,
  };
});
